module.exports = __webpack_public_path__ + "img/icon16.30c811ba.svg";